// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";

import { useMutation } from "@tanstack/react-query";
import { fetchPost, fetchPostSilance, fetchGet } from "../../../fetchers";
import { toast } from "react-toastify";
import { Card } from "@material-tailwind/react";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// import { alertService } from "../../../../services/AlertService";

// import Loading from "../../../../components/loading/Loading";
import TableKaryawanPayrollDetail from "../../../components/tablecard/TableKaryawanPayrollDetail";

import { Colors } from "../../../assets/Colors";
import { isRequired, useForm } from "../../../components/isRequired";
import { KaryawanSelectorBuilder } from "../../hrd/karyawan/KaryawanSelector";

const PayrollPageDetail = ({}) => {
  // let initialState = {};
  const paramsUrl = useParams();
  const mutation = useMutation((param) =>
    fetchGet("getKaryawanPayrollDetail", param)
  );
  const mutationSave = useMutation((param) => fetchPost("SaveDetail", param));

  const validations = [];

  let initialState = {
    Bulan: new Date(),
  };

  const [param, setParam] = useState({
    Bulan: (new Date().getMonth() + 1).toString(),
    Tahun: new Date().getFullYear().toString(),
    Pin: paramsUrl.id,
  });

  const {
    changed,
    values,
    isValid,
    errors,
    touched,
    changeHandler,
    editHandler,
    clearHandler,
    submitHandler,
    customHandler,
  } = useForm(initialState, validations);

  useEffect(() => {
    mutation.mutate(param);
  }, [param]);

  const filterApi = () => {
    setParam({
      Bulan: isNaN((new Date(values.Bulan).getMonth() + 1).toString())
        ? (new Date().getMonth() + 1).toString()
        : (new Date(values.Bulan).getMonth() + 1).toString(),
      Tahun: isNaN(new Date(values.Bulan).getFullYear().toString())
        ? new Date().getFullYear().toString()
        : new Date(values.Bulan).getFullYear().toString(),
      Pin: paramsUrl.id,
    });
  };

  const onchangeCheck = (e) => {
    e.target.checked = e.target.checked;
    customHandler(e.target.checked, e.target.name);
  };

  const saveDetail = () => {
    mutationSave.mutate(values, {
      onSuccess: () => {
        toast.success("Data berhasil disimpan!", {
          position: "top-center",
          autoClose: 1500,
        });
        mutation.mutate(param);
      },
      onError: () => {
        toast.error("Gagal menyimpan data", { position: "top-center" });
      },
    });
  };

  const periodeLabel = (() => {
    const bln = parseInt(param.Bulan);
    const thn = parseInt(param.Tahun);
    if (isNaN(bln) || isNaN(thn)) return "";
    const start = new Date(thn, bln - 2, 21);
    const end = new Date(thn, bln - 1, 20);
    const fmt = (d) =>
      d.toLocaleDateString("id-ID", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
    return `${fmt(start)} – ${fmt(end)}`;
  })();

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>

        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <Card>
              <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                <div className={"w-1/4"}>
                  <HrdInputGenerator
                    type={"bulan"}
                    name={"Bulan"}
                    title={"Bulan"}
                    value={values}
                    required={true}
                    onChange={customHandler}
                    touched={touched}
                    errors={errors}
                    size={"full"}
                  />
                </div>
                <div className={"w-1/4"}>
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Buka data
                  </label>

                  <button
                    type="button"
                    onClick={filterApi}
                    className=" text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2 "
                  >
                    Buka
                  </button>
                </div>
                <div className={"w-1/4"}>
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Save data
                  </label>

                  <button
                    type="button"
                    onClick={saveDetail}
                    className=" text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2 "
                  >
                    Save
                  </button>
                </div>
              </div>

              <div className="px-4 pb-2 text-sm text-gray-600">
                Periode: <span className="font-semibold">{periodeLabel}</span>
                {" · "}PIN {paramsUrl.id}
              </div>

              <div className="flex flex-col items-center content-center ">
                <TableKaryawanPayrollDetail
                  usingMutation={true}
                  mutation={mutation}
                  hrd={true}
                  primaryID="ID"
                  transaksi={true}
                  tableData={mutation.data}
                  pin={paramsUrl.id}
                  title={paramsUrl.id}
                  valuescheck={values}
                  onchangeCheck={onchangeCheck}
                  handleSearch={() => {}}
                  searchPlaceholder=""
                />
              </div>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default PayrollPageDetail;
